import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import util from '@/functions'
import API from '@/services'
import Login from '@/views/Login'
import Dashboard from '@/views/Dashboard'
import NotFound from '@/views/NotFound'
import RewardUnavailable from '@/views/RewardUnavailable'
import Settings from '@/views/Settings'
import Program from '@/views/Program'
import SavedRewards from '@/views/SavedRewards'
import ResetPassword from '@/views/ResetPassword'
import ForgotPassword from '@/views/ForgotPassword'
import AccountSetup from '@/views/AccountSetup'
import Page from '@/views/Page'
import Signup from '@/views/Signup'
import RewardsDashboard from '@/views/RewardsDashboard'
import Impersonate from '@/views/Impersonate'
import RewardsResults from '@/views/RewardsResults'
import RewardsSingle from '@/views/RewardsSingle'
import MyOrders from '@/views/MyOrders'
// import Programs from '@/views/Programs'
import ProgramDashboard from '@/views/ProgramDashboard'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  getRoutes (isVanityUrl, customRoutes, router) {
    var routes = [{
      path: '/',
      redirect: { name: 'Login' }
    },
    {
      path: (isVanityUrl ? '/' : '') + 'login',
      name: 'Login',
      component: Login,
      beforeEnter: util.redirectIfLoggedIn(router)
    },
    {
      path: (isVanityUrl ? '/' : '') + 'dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: util.requireAuth(router)
    },
    {
      path: (isVanityUrl ? '/' : '') + 'settings',
      name: 'Settings',
      component: Settings,
      beforeEnter: util.requireAuth(router)
    },
    {
      path: (isVanityUrl ? '/' : '') + 'program/:id',
      name: 'Program',
      component: Program,
      beforeEnter: util.requireAuth(router)
    },
    {
      path: (isVanityUrl ? '/' : '') + 'rewards',
      name: 'Rewards',
      component: RewardsDashboard,
      beforeEnter: util.requireAuth(router)
    },
    {
      path: (isVanityUrl ? '/' : '') + 'rewards/results',
      name: 'Rewards Results',
      component: RewardsResults,
      beforeEnter: util.requireAuth(router)
    },
    {
      path: (isVanityUrl ? '/' : '') + 'rewards/:id',
      name: 'Single Reward',
      component: RewardsSingle,
      beforeEnter: util.requireAuth(router)
    },
    {
      path: (isVanityUrl ? '/' : '') + 'orders',
      name: 'MyOrders',
      component: MyOrders,
      beforeEnter: util.requireAuth(router)
    },
    {
      path: (isVanityUrl ? '/' : '') + 'saved-rewards',
      name: 'SavedRewards',
      component: SavedRewards,
      beforeEnter: util.requireAuth(router)
    },
    /*
    {
      path: (isVanityUrl ? '/' : '') + 'programs',
      name: 'Programs',
      component: Programs,
      beforeEnter: util.requireAuth(router)
    },
    */
    {
      path: (isVanityUrl ? '/' : '') + 'rewards-unavailable',
      name: 'RewardUnavailable',
      component: RewardUnavailable,
      beforeEnter: util.requireAuth(router)
    },
    {
      path: (isVanityUrl ? '/' : '') + 'signup',
      name: 'Signup',
      component: Signup,
      beforeEnter: util.requireEnrollment(router)
    },
    {
      path: (isVanityUrl ? '/' : '') + 'reset-password/:email/:token',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: (isVanityUrl ? '/' : '') + 'expired-password',
      name: 'ExpiredPassword',
      component: ResetPassword,
      beforeEnter: util.requireExpiredPassword(router)
    },
    {
      path: (isVanityUrl ? '/' : '') + 'impersonate',
      name: 'Impersonate',
      component: Impersonate
    },
    {
      path: (isVanityUrl ? '/' : '') + 'forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: (isVanityUrl ? '/' : '') + 'account-setup/:token',
      name: 'AccountSetup',
      component: AccountSetup
    },
    {
      path: (isVanityUrl ? '/' : '') + 'program-dashboard/:id',
      name: 'ProgramDashboard',
      component: ProgramDashboard,
      beforeEnter: util.requireAuth(router)
    }]

    for (var i = 0; i < customRoutes.length; i++) {
      var customRoute = {
        path: (isVanityUrl ? '/' : '') + customRoutes[i].url,
        name: 'Page_' + customRoutes[i].id,
        component: Page,
        meta: {
          id: customRoutes[i].id,
          name: customRoutes[i].title
        },
        props: { id: customRoutes[i].id }
      }
      if (customRoutes[i].availability === 'logged_in') {
        customRoute.beforeEnter = util.requireAuth(router)
      }
      routes.push(customRoute)
    }

    routes.push({
      path: (isVanityUrl ? '/' : '') + '*',
      name: 'NotFound',
      component: NotFound
    })

    return routes
  }
})

const shouldCallApi = (to) => {
  // Not found route
  if (to.name === 'NotFound') {
    return false
  }

  // No website loaded
  if (store.state.websiteConfig.url === null) {
    return true
  }

  // Changing websites
  if (
    typeof to.params.website !== 'undefined' &&
    to.params.website !== store.state.websiteConfig.url
  ) {
    return true
  }

  return false
}

router.beforeEach((to, from, next) => {
  /** Redirect to Expired Password page if needed */
  let ignoreOnExpiredPassword = ['Impersonate', 'ExpiredPassword']

  if (!ignoreOnExpiredPassword.includes(to.name) && util.isLoggedIn() && util.isPasswordExpired()) {
    next({ name: 'ExpiredPassword', params: { website: to.params.website } })
    return
  }

  // detect if we're navigating to a new website
  // if so, load the website config from the api (todo - decide if the already loaded configs should be cached in the app)
  // on success proceed with the navigation
  // on error display a 404 page
  if (shouldCallApi(to)) {
    API.get('website-config?url=' + encodeURIComponent(window.location.href))
      .then(function (response) {
        let websiteConfig = response.data.websiteConfig

        store.commit('UPDATE_WEBSITE_CONFIG', websiteConfig)
        store.commit('UPDATE_LOGIN_STATUS', util.isLoggedIn())
        util.removePlatformSpecificHeaderElements()
        util.updateWebsiteTitle(websiteConfig.name)

        store.dispatch('WEBSITE_CONFIG_AUTH_UPDATE', router)
        .then(() => {
          // on initial app load the route is not being resolved to the component correctly so we have to reload it
          var nextObject = {path: to.path, replace: true}
          if (to.query) {
            // adding query string to the route in case it have it, if not it will redirect
            // to /impersonate without the query string on the url
            nextObject.query = to.query
          }
          next(nextObject)
        })
      })
      .catch((err) => {
        if (err.response.status === 404) {
          var isVanityUrl = window.location.hostname !== process.env.PLATFORM_HOST
          router.addRoutes([{
            path: (isVanityUrl ? '/' : '') + '*',
            name: 'NotFound',
            component: NotFound
          }])
          next({ name: 'NotFound' })
        }
      })
  } else {
    // In cases of browser Back button, remove blurring from possibly opened PointsLedger
    util.closeModals()
    next()
  }
})

router.beforeResolve((to, from, next) => {
  // list of routes which contain security tokens and shouldn't be logged
  const nonLoggableUrls = ['ResetPassword', 'AccountSetup', 'Impersonate']
  if (to.name !== null && nonLoggableUrls.indexOf(to.name) === -1 && util.isLoggedIn()) {
    // log the page visit
    let eventData = {}
    eventData.details = to.fullPath
    store.dispatch('LOG_EVENT', eventData)
  }

  // redirect to not found if navigating to rewards page and catalog is not enabled
  let pax = store.getters.participant
  const rewardRoutes = ['Rewards', 'Rewards Results', 'Single Reward', 'SavedRewards']
  if (!pax.catalog_is_enabled && to.name !== null && rewardRoutes.indexOf(to.name) !== -1) {
    if (to.name === 'Single Reward') {
      // navigate to reward unavailable for single reward to avoid creating a loop
      // where /rewards/123 would redirect to /rewards/123-, then /rewards/123-- etc.
      next({ name: 'RewardUnavailable', replace: true, params: { website: to.params.website } })
    } else {
      // mavigate to the current url with the addition of '-' so that it'd be shown as a 404
      // error but the url wouldn't be the root url of the platform website/vanity url
      // and the dashboard link on the 404 page would work correctly
      // would happen if someone loads one of the reward urls in a new tab or if navigating
      // via link/back button after participant has lost the catalog relationship and it was
      // updated in the vuex state
      next({ path: to.path + '-', replace: true })
    }
    return
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js